import { gql } from "@apollo/client";
import { tag } from "../../ssr/graphql/models/tag";
import { post } from "../../ssr/graphql/models/post";

export const searchResultsQuery = gql`
  query SearchResults($searchQuery: String!, $afterPost: String, $afterTag: String) {
    posts(where: { search: $searchQuery }, first: 50, after: $afterPost) {
      nodes {
        ${post}
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }

    tags(where: { search: $searchQuery }, first: 50, after: $afterTag) {
      nodes {
        ${tag}
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
